/* eslint-disable */
import {
  red,
  green,
  blue,
  cyan,
  magenta,
  yellow,
  gray,
  orange,
  salmon,
  turquoise,
  purple,
  common
} from './color-palettes';

export const theme = {
  isTouchDevice: navigator.maxTouchPoints > 2 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  },
  common: {
    enableCaretsForDropdown: true,
    enableRounded: true,
    enableShadows: true,
    enableGradients: false,
    spacerSize: '1rem'
  },
  text: {
    primary: '',
    secondary: '',
    disabaled: '',
    hint: '',
    icon: ''
  },
  box: {
    lightBorder: '',
    mediumBorder: '',
    darkBorder: ''
  },
  shape: {
    borderColor: '',
    borderRadius: 4
  },
  button: {
    base: {
      fontSize: '1rem',
      padding: '0.5rem',
      borderRadius: '4px'
    },
    primary: {
      props: {
        background: blue[500],
        color: blue[800],
        borderColor: blue[500],
      },
      hoverProps: {
        background: blue[600],
        color: blue[100],
        borderColor: blue[600]
      },
      outlineProps: {
        background: common.transparent,
        color: blue[500],
        border: `1px solid ${blue[500]}`
      },
      textProps: {
        background: common.transparent,
        border: 'none',
        color: blue[500],
        hoverProps: { color: blue[200] }
      },
      disabledProps: {
        opacity: '0.7'
      },
    },
    warning: {
      props: {
        background: salmon[500],
        color: salmon[800],
        borderColor: salmon[500],
      },
      hoverProps: {
        background: salmon[600],
        color: salmon[100],
        borderColor: salmon[100],
      },
      outlineProps: {
        background: common.transparent,
        color: salmon[500],
        border: `1px solid ${salmon[500]}`
      },
      textProps: {
        background: common.transparent,
        border: 'none',
        color: salmon[500],
        hoverProps: { color: salmon[200] }
      },
      disabledProps: {},
    },
    success: {
      props: {
        background: green[500],
        color: green[800],
        borderColor: green[500],
      },
      hoverProps: {
        background: green[600],
        color: green[100],
        borderColor: green[100],
      },
      outlineProps: {
        background: common.transparent,
        color: green[500],
        border: `1px solid ${green[500]}`
      },
      textProps: {
        background: common.transparent,
        border: 'none',
        color: green[500],
        hoverProps: { color: green[200] }
      },
      disabledProps: {},
    },
    danger: {
      props: {
        background: yellow[500],
        color: yellow[800],
        borderColor: yellow[500],
      },
      hoverProps: {
        background: yellow[600],
        color: yellow[100],
        borderColor: yellow[600],
      },
      outlineProps: {
        background: common.transparent,
        color: yellow[500],
        border: `1px solid ${yellow[500]}`
      },
      textProps: {
        background: common.transparent,
        border: 'none',
        color: yellow[500],
        hoverProps: { color: yellow[200] }
      },
      disabledProps: {},
    },
    error: {
      props: {
        background: red[500],
        color: red[800],
        borderColor: red[500],
      },
      hoverProps: {
        background: red[600],
        color: red[100],
        borderColor: red[600],
      },
      outlineProps: {
        background: common.transparent,
        color: red[500],
        border: `1px solid ${red[500]}`
      },
      textProps: {
        background: common.transparent,
        border: 'none',
        color: red[500],
        hoverProps: { color: red[200] }
      },
      disabledProps: {},
    },
  },
  pressedButton: {
    borderColor: gray[500],
    textColor: gray[500],
    background: common.transparent,
    pressedBorderColor: blue[500],
    pressedTextColor: common.white,
    pressedBackground: blue[500],
    hoverBorderColor: blue[300],
    hoverBackground: blue[300],
    hoverTextColor: common.white,
    borderRadius: '2px'
  },
  drawer: {
    props: {
      background: gray[800],
      color: gray[500],
      borderColor: gray[700],
    },
    maskProps: {
      background: blue[800]
    }
  },
  mask: {
    props: {
      background: blue[800]
    },
    textProps: {
      color: common.white
    }
  },
  checkbox: {
    isHandOnHover: true,
    checkboxBorderRadius: '2px',
    checkboxColor: gray[200],
    checkboxBackground: gray[200],
    checkboxHoverColor: blue[500],
    checkboxCheckedColor: blue[500],
    checkboxCheckedBackground: blue[500],
    checkboxCheckedTickColor: gray[800],
    checkboxIndeterminateColor: blue[500],
    checkboxIndeterminateBackground: blue[500],
    checkboxIndterminateTickColor: blue[500],
    checkboxDisabledColor: gray[500],
    checkboxDisabledBackground: gray[500],
    checkboxDisabledTickColor: gray[700],
  },
  textInput: {
    fontSize: '1rem',
    fontWeight: 'normal',
    padding: '0.25rem',
    background: gray[900],
    color: gray[100],
    placeholderColor: gray[400],
    caretColor: gray[100],
    borderColor: gray[500],
    focusedBorderColor: blue[500],
    warningBorderColor: yellow[500],
    errorBorderColor: red[500],
    dangerBorderColor: salmon[500],
  },
  numberInput: {
    props: {
      background: gray[900],
      color: gray[100],
      caretColor: gray[100],
      borderColor: gray[500]
    },
    buttonProps: {
      background: gray[500],
      color: gray[200],
    },
    focusedProps: {
      focusedBorderColor: blue[500]
    }
  },
  radioButton: {
    cursor: 'pointer',
    radioBtnColor: gray[200],
    radioBtnHoverColor: blue[500],
    radioBtnSelectedColor: blue[500],
    radioBtnDisabledColor: gray[300]
  },
  switchBtn: {
    isHandOnHover: true,
    cursor: 'pointer',
    switchOffBackground: gray[500],
    switchOffLeverColor: gray[200],
    switchOnBackground: blue[700],
    switchOnLeverColor: blue[500],
    switchDisabledBackground: gray[500],
    switchDisabledLeverColor: gray[400]
  },
  navbar: {
    navbarHeight: '2.5rem',
    navbarSeparatorHeight: '1px',
    navbarBrandMarginLeft: '4px',
    navbarBrandMarginRight: '0px',
    navbarBackground: gray[600],
    navbarColor: gray[300],
    navbarSeparatorColor: blue[900],
    navItemBackground: gray[600],
    navItemColor: gray[400],
    navItemHoverBackground: gray[800],
    navItemHoverColor: gray[400],
    navItemActiveBackground: blue[700],
    navItemActiveColor: gray[400]
  },
  heading: {
    h1: {
      fontFamily: 'Lato',
      fontWeight: 'lighter',
      fontSize: '3rem'
    },
    h2: {
      fontFamily: 'Lato',
      fontWeight: 'lighter',
      fontSize: '2.55rem'
    },
    h3: {
      fontFamily: 'Lato',
      fontWeight: 'lighter',
      fontSize: '2rem'
    },
    h4: {
      fontFamily: 'Lato',
      fontWeight: 'lighter',
      fontSize: '1.5rem'
    },
    h5: {
      fontFamily: 'Lato',
      fontWeight: 'normal',
      fontSize: '1.25rem'
    },
    h6: {
      fontFamily: 'Lato',
      fontWeight: 'normal',
      fontSize: '1rem'
    }
  },
  datePicker: {
    showCircledBorder: false,
    // Date Label
    dateLabelColor: gray[200],
    dateLabelBorderColor: gray[400],

    // Menu
    background: gray[500],

    // Header
    headerBgColor: gray[600],
    headerTextColor: gray[200],
    headerBorderColor: gray[700],

    // Header nav buttons
    headerNavBtnBgColor: gray[600],
    headerNavBtnTextColor: gray[200],

    // Header month & year buttons
    activeMonthHeaderTextColor: common.white,
    activeYearHeaderTextColor: common.white,
    monthHeaderBg: gray[700],
    monthHeaderTextColor: gray[200],
    yearHeaderBg: gray[700],
    yearHeaderTextColor: gray[200],
    activeMonthHeaderBg: blue[500],
    activeYearHeaderBg: blue[500],

    // Footer
    footerBgColor: gray[600],
    footerTextColor: blue[500],
    footerBorderColor: gray[700],

    // Items - Dates/Months/Years
    itemBgColor: gray[500],
    itemTextColor: gray[200],
    itemSecondaryTextColor: gray[400], // weekends
    itemHoverBgColor: gray[700],
    itemHoverTextColor: gray[200],

    // Current Date
    currentItemBgColor: gray[500],
    currentItemTextColor: gray[200],
    currentItemHoverBgColor: gray[700],
    currentItemHoverTextColor: gray[200],
    currentItemBorderColor: blue[500],
    currentItemHoverBorderColor: blue[500],

    // Selected Date
    selectedItemHoverTextColor: common.white,
    selectedItemTextColor: common.white,
    selectedItemBgColor: blue[500],
    selectedItemHoverBgColor: blue[500],
    selectedItemBorderColor: blue[500],
    selectedItemHoverBorderColor: blue[500]
  },
  popupmenu: {
    bgColor: gray[700]
  },
  timePicker: {
    labelColor: gray[200],
    labelBorderColor: gray[400],
    menuBgColor: gray[500],
    menuTextColor: gray[200],
    menuBorderColor: gray[700],
    headerBgColor: gray[600],
    headerTextColor: gray[200],
    headerBorderColor: gray[700],
    footerBgColor: gray[600],
    footerTextColor: gray[200],
    footerBorderColor: gray[700],
    selectedBgColor: blue[500],
    selectedTextColor: common.white,
    hoverBgColor: blue[500],
    hoverTextColor: common.white
  },
  dialogBox: {
    maskOpacity: '0.5',
    maskBackground: blue[500],
    borderColor: gray[600],
    headerHeight: '2.5rem',
    headerBackground: gray[700],
    headerColor: gray[300],
    headerFontWeight: 'bold',
    headerFontSize: '1rem',
    headerBorderColor: gray[900],
    headerTextPadding: '4px 0 4px 8px',
    bodyBackground: gray[700],
    bodyColor: gray[300],
    dialogBoxRadius: '4px',
    closeBtnHoverBg: salmon[500]
  },
  tabs: {
    tabsContainerBorder: gray[600],
    background: gray[800],
    hoverBackground: gray[600],
    activeBackground: blue[800],
    indicatorBackground: gray[800],
    indicatorHoverBackground: gray[600],
    indicatorActiveBackground: blue[400],
    textColor: gray[200],
    hoverTextColor: gray[200],
    activeTextColor: blue[400],
    fontSize: '14px',
    fontWeight: '700',
    tabPadding: '0',
    tabMargin: '16px'
  },
  dataGrid: {
    gridBackground: blue[900],
    // gridBorderColor: yellow[500],
    gridBorderColor: 'transparent',
    gridPinnedBorderColor: blue[400],
    gridMaskColor: blue[600],
    gridRowsContainerBackground: blue[800],
    gridHighlightTextBackground: blue[400],
    gridHighlightTextColor: common.white,
    // Header
    gridHeaderBackground: gray[600],
    gridHeaderTextColor: blue[200],
    gridHeaderRightBorderColor: gray[800],
    gridHeaderBottomBorderColor: gray[800],
    gridHeaderFontSize: '14px',
    gridHeaderFilterFontSize: '12px',
    gridHeaderFilterFontWeight: '700',
    gridHeaderHeight: '48px',
    gridHeaderFilterMenuBackground: gray[800],
    gridHeaderFilterMenuTextColor: gray[200],
    gridHeaderFilterMenuBorderColor: magenta[500],
    // Rows
    gridRowsBackground: gray[800],
    gridRowsAltBackground: gray[800],
    gridRowsTextColor: blue[200],
    gridRowsLinkTextColor: blue[400],
    gridRowsRightBorderColor: gray[600],
    // gridRowsRightBorderColor: 'transparent',
    gridRowsBottomBorderColor: gray[600],
    gridRowsFontSize: '12px',
    gridRowsFontWeight: '700',
    gridRowsHoverBackground: blue[900],
    gridRowsHoverTextColor: common.white,
    gridRowSelectionBackground: blue[800],
    gridRowSelectionOpacity: '0%',
    // Footer
    gridFooterBackground: gray[600],
    gridFooterTextColor: blue[200],
    gridFooterFontSize: '14px',
    gridFooterRightBorderColor: gray[800],
    gridFooterTopBorderColor: blue[400],
    gridFooterHeight: '32px',
    // Pager
    gridPagerBackground: gray[600],
    // gridPagerBackground: 'transparent',
    gridPagerTopBorderColor: gray[800],
    gridPagerTextColor: blue[200],
    gridPagerFontSize: '12px',
    gridPagerDropdownTextColor: blue[400],
    gridPagerIconsTextColor: gray[600],
    gridPagerIconsBackground: blue[200],
    gridPagerHeight: 32
  },
  toast: {
    color: gray[300],
    background: gray[500],
    borderColor: blue[700],
    headerFontSize: '0.75rem',
    headerFontWeight: 'bold',
    borderRadius: '4px',
    closeBtnHoverColor: salmon[500]
  },
  dropdown: {
    menuBackground: gray[800],
    menuBorderColor: gray[500],
    menuTextColor: gray[500],
    fontSize: '1rem',
    fontWeight: '400',
    menuItemTextColor: gray[200],
    menuItemActiveTextColor: gray[200],
    menuItemHoverTextColor: blue[400],
    menuItemDisabledTextColor: gray[200],
    menuItemDisabledTextColorOpacity: 0.5,
    menuItemBackgroundColor: gray[800],
    menuItemActiveBackgroundColor: blue[800],
    menuItemHoverBackgroundColor: gray[600],
    menuItemDisabledBackgroundColor: gray[800],
    menuItemIndicatorColor: gray[800],
    menuItemActiveIndicatorColor: blue[400],
    menuItemHoverIndicatorColor: gray[600],
    menuItemSeparatorColor: gray[600]
  },
  chipContainer: {
    borderWidth: '1px',
    borderColor: blue[500],
    background: gray[900],
    color: gray[300],
    chipInputBackground: gray[900]
  },
  chip: {
    background: blue[100],
    color: gray[100],
    height: '1.5rem',
    fontSize: '0.75rem',
    closeBtnHoverColor: red[500]
  }
};
